var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTakeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14.6663H18.5V13.333H8.508C8.2 13.325 7.83333 13.203 7.83333 12.6663C7.83333 12.1297 8.2 12.0077 8.508 11.9997H18.5V2.66634C18.5 1.93101 17.902 1.33301 17.1667 1.33301H8.5C7.696 1.33301 6.5 1.86567 6.5 3.33301V12.6663C6.5 14.1337 7.696 14.6663 8.5 14.6663ZM7.83333 5.33301V3.33301C7.83333 2.79634 8.2 2.67434 8.5 2.66634H17.1667V10.6663H7.83333V5.33301Z",
    fill: "#6F6F6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83301 4H15.833V5.33333H9.83301V4Z",
    fill: "#6F6F6F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0715 16.3375C22.6003 15.8917 21.8657 15.9208 21.3705 16.3375L17.6812 19.4167C17.23 19.7958 16.667 20 16.084 20H11.3605C11.0091 20 10.7217 19.7 10.7217 19.3333C10.7217 18.9667 11.0091 18.6667 11.3605 18.6667H14.4869C15.1218 18.6667 15.7127 18.2125 15.8165 17.5583C15.9483 16.725 15.3334 16 14.5548 16H8.16624C7.08818 16 6.04605 16.3875 5.20755 17.0958L3.35088 18.6667H1.13885C0.787484 18.6667 0.5 18.9667 0.5 19.3333V23.3333C0.5 23.7 0.787484 24 1.13885 24H15.3853C15.9642 24 16.5272 23.7958 16.9824 23.4167L23.0196 18.375C23.6265 17.8708 23.6744 16.9042 23.0715 16.3375Z",
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakeIcon);
export default __webpack_public_path__ + "static/media/takeIcon.164cc269ee4308ab2821a87b3bf5bab9.svg";
export { ForwardRef as ReactComponent };